<template>
    <div class="mt-3" v-if="empresa_selecionada">
        <div v-if="usuario.pessoa.funcionario.funcionario_cargo_id === 1">
            <div class="flex-row mb-3">
                <div class="col-xs-12 col-md">
                    <h4 class="simulator-title loaded">Conclusão</h4>
                </div>
                <div class="col-xs-12 col-md-4">
                    <label class="text-default">Selecionar Empresa</label>
                    <select v-model="empresa_id" class="browser-default" @change="trocarEmpresa">
                        <option :value="empresa.empresa_id" v-for="empresa in empresas" :key="`e-${empresa.empresa_id}`">{{ empresa.empresa_nome_fantasia }}</option>
                    </select>
                </div>
            </div>
            <quill-editor v-model="texto" ref="quill" :options="quillOptions"></quill-editor>
            <div class="right-align mt-2">
                <button class="btn btn-default" @click.prevent="salvar" :disabled="carregando">Salvar</button>
            </div>
        </div>
        <div v-else v-html="texto" v-once></div>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import Auth from "@/store/auth";
import { api } from "@/helpers/api";
import modal from "@/helpers/wm-modal";

export default {
    name: 'TextoFinal',
    components: {quillEditor},


    async created() {

        if (this.usuario.pessoa.funcionario.funcionario_cargo_id === 1) {
            const {data: {result: {data: empresas}}} = await api.get('empresa');
            empresas.sort((a, b) => a.empresa_nome_fantasia > b.empresa_nome_fantasia)
            this.empresas = empresas;
        }

    },

    data() {
        return {
            empresas: [],
            carregando: false,
            texto: '',
            empresa_id: null
        }
    },


    props: {
        empresa_selecionada: {
            type: Object,
            default: null
        }
    },

    methods: {
        async plot () {

            const texto =
            `<div class="page_logo" style="page-break-before: always;">
                <div class="site"></div>
                <div style="padding-top: 300px">${this.texto}</div>
                <div class="logo"></div>
            </div>`;


            return texto;
        },

        async salvar() {

            this.empresa_selecionada.texto_final = this.texto;

            this.carregando = true;

            try {
                await api.put(`empresa/${this.empresa_selecionada.empresa_id}`, this.empresa_selecionada);
                modal.alert({text: 'Texto final salvo com sucesso!', title: 'Sucesso'})

            } finally {
                this.carregando = false
            }

        },

        trocarEmpresa() {

            const empresa = this.empresas.find(item => item.empresa_id === this.empresa_id);

            this.$emit('update:empresa_selecionada', empresa);
        }
    },

    computed: {

        oabprev() {
            return this.empresa_selecionada && this.empresa_selecionada.empresa_nome_fantasia.toLowerCase().includes('oabprev')
        },

        quillOptions() {

            const handlers = {
                image: this.imageHandler,
            };

            const colors = [
                this.empresa_selecionada.cor_primaria,
                this.empresa_selecionada.cor_secundaria,
                "#ffc059",
                "#ff6565",
                "#708bcc",
                "#4ad991",
                "#52dfec",
                "#a3a0fb",
                '#095db0',
                '#000',
                '#666',
                '#AAA',
                '#FFF',
            ];
            const toolbar = [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'link'],
                // [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'align': [] }],
                [{ 'color': colors}, { 'background': colors }],
                ['clean']
            ];

            const clipboard = {
                matchVisual: false
            };


            return {
                modules: {
                    toolbar: {
                        container: toolbar,
                        handlers
                    },
                    clipboard,
                }
            };
        },

        usuario: () => Auth.state.user,
    },

    watch: {
        empresa_selecionada: {
            immediate: true,
            deep: true,
            handler (empresa) {
                this.texto = empresa.texto_final
                this.empresa_id = empresa.empresa_id;

                console.log(empresa)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";
.block{
    width: 300px;
    margin-left: 120px;
    display: contents;
}

.texto{
    margin-top: 15px;
    margin-bottom: 15px;
}

::v-deep .texto{
    @extend .texto;
}

.m5 {
    margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/TextoFinal.vue